import { useEffect, useState } from 'react';
import { Button, Sheet } from './ui';

/** Kleiner Eingabedialog statt window.prompt */
export function PromptDialog({
  open,
  title,
  label,
  initial = '',
  type = 'text',
  confirm = 'Speichern',
  hint,
  onClose,
  onSubmit,
}: {
  open: boolean;
  title: string;
  label: string;
  initial?: string;
  type?: 'text' | 'number' | 'email';
  confirm?: string;
  hint?: string;
  onClose: () => void;
  onSubmit: (value: string) => void;
}) {
  const [value, setValue] = useState(initial);
  useEffect(() => {
    if (open) setValue(initial);
  }, [open, initial]);
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()} title={title} side="center">
      <form
        className="flex flex-col gap-3 p-4"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(value);
        }}
      >
        <label className="flex flex-col gap-1.5 text-sm">
          <span className="font-medium">{label}</span>
          <input
            autoFocus
            type={type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="min-h-11 rounded-lg border border-[var(--line)] bg-transparent px-3 text-base sm:text-sm"
          />
        </label>
        {hint && <p className="text-xs text-[var(--ink-soft)]">{hint}</p>}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" onClick={onClose}>
            Abbrechen
          </Button>
          <Button type="submit" variant="primary">
            {confirm}
          </Button>
        </div>
      </form>
    </Sheet>
  );
}
